// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as LocaleHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as GAEventsConstants$PorterinFeature from "../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../core/helpers/PublishEventsHelper.mjs";

function clickEventName(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateClickBd;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateClickUae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateClickTurkey;
  } else {
    return GAEventsConstants$PorterinFeature.gaFareEstimateClick;
  }
}

function successEventName(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulBd;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulUae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulTurkey;
  } else {
    return GAEventsConstants$PorterinFeature.gaFareEstimateSuccessful;
  }
}

function successPayload(name, mobile, requirement, utm_source, utm_campaign, service_category) {
  return "1_" + name + "#2_" + mobile + "#3_frequency-" + requirement + "#4_" + utm_source + "#5_" + utm_campaign + "#6_" + service_category;
}

function successEvent(page, name, mobile, requirement, utm_source, utm_campaign, service_category, city, locale, event_name) {
  PublishEventsHelper$PorterinFeature.publishEvents(page, event_name, successPayload(name, mobile, requirement, utm_source, utm_campaign, service_category));
  PublishEventsHelper$PorterinFeature.publishEventsV2(successEventName(locale), {
        name: name,
        mobile_number: mobile,
        city: Belt_Option.getWithDefault(city, ""),
        frequency: requirement,
        language_selected: LocaleHelpers$PorterinUtils.localeToString(locale)
      });
}

export {
  clickEventName ,
  successEventName ,
  successPayload ,
  successEvent ,
}
/* PublishEventsHelper-PorterinFeature Not a pure module */
